export const getPriorityColor = (priority: string) => {
  switch (priority) {
    case "High":
      return "#C00F0C";
    case "Medium":
      return "#975102";
    case "Low":
      return "#009951";
    default:
      return "#000000";
  }
};
